module.exports = __webpack_public_path__ + "img/seo-and-web.e5f3fec9.svg";